import { fakeApiHelper } from '~~utils/CommonUtils';
import ApiService from '~~commonAPIs/ApiService';

const debugStatus = {
  list: false,
};

const Member = {
  list: () => {
    if (debugStatus.list) {
      return fakeApiHelper(200, 'success', {
        error: false,
        message: 'Get members successfully',
      });
    }

    return ApiService.get(`/api/members`);
  },
};

export default Member;
